/* src/app/modules/auth/pages/confirm/confirm.component.scss */
.line {
  white-space: break-spaces;
}
/*# sourceMappingURL=confirm.component-BXW6Y3JV.css.map */
